// /onboarding — возврат к тому экрану, где человек остановился.
//
// Раньше здесь стоял жёсткий редирект на первый шаг, и это было видно ровно в
// том месте, где обиднее всего: человек начинал тур на телефоне, открывал на
// ноутбуке — и проходил его сначала. Позиция теперь серверная
// (`onboarding_state.current_step_key`), а адрес шага выводит `resumeStepPath`.
//
// Почему компонент, а не `beforeLoad`-редирект: позицию надо СПРОСИТЬ у
// сервера, а `beforeLoad` во всех роутах приложения синхронный. Ждать нечего —
// пока ответ не пришёл, показываем оболочку тура, а не пустой экран.
import { createFileRoute, useNavigate, useRouterState } from "@tanstack/react-router";
import { useEffect } from "react";
import { resumeStepPath, shouldResumeFrom } from "@/components/onboarding/_steps";
import { OnboardingShell } from "@/components/onboarding/onboarding-shell";
import { api } from "@/lib/trpc-client";

export const Route = createFileRoute("/onboarding/")({
	component: OnboardingResume,
});

function OnboardingResume(): React.ReactElement {
	const navigate = useNavigate();
	const progress = api.onboarding.getProgress.useQuery();
	// Адрес, а не матч: под чужим адресом этот компонент может оказаться,
	// пока матч отстаёт от `location`, — и тогда уводить на шаг нельзя
	// (`shouldResumeFrom`, OXEM-841).
	const pathname = useRouterState({ select: (s) => s.location.pathname });

	// Сбой запроса (офлайн, 500) — уводим на первый экран: тур обязан
	// проходиться и без ответа сервера. `isPending` при этом ждём: редирект «на
	// всякий случай» отправил бы в начало ровно тех, чью позицию мы вот-вот
	// узнаем.
	const isSettled = !progress.isPending;
	const isOwnAddress = shouldResumeFrom(pathname);

	useEffect(() => {
		if (!isSettled || !isOwnAddress) return;
		void navigate({
			to: resumeStepPath(progress.data?.currentStep ?? null),
			replace: true,
		});
	}, [isSettled, isOwnAddress, progress.data?.currentStep, navigate]);

	return <OnboardingShell>{null}</OnboardingShell>;
}
